module.exports = __webpack_public_path__ + "img/2X2_1.79bc1fcf.jpg";